import { render } from "./WritingInterviewPage.vue?vue&type=template&id=3bba5e3b&scoped=true"
import script from "./WritingInterviewPage.vue?vue&type=script&lang=js"
export * from "./WritingInterviewPage.vue?vue&type=script&lang=js"

import "./WritingInterviewPage.vue?vue&type=style&index=0&id=3bba5e3b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bba5e3b"]])

export default __exports__